var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 12.833C22.75 18.7637 16.1787 22.7389 14.4256 23.6939C14.1568 23.8403 13.8432 23.8403 13.5744 23.6939C11.8213 22.7389 5.25 18.7637 5.25 12.833C5.25 7.58301 9.48967 4.08301 14 4.08301C18.6667 4.08301 22.75 7.58301 22.75 12.833Z",
    stroke: "#1B1836",
    strokeWidth: 1.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0007,
    cy: 12.8337,
    r: 3.86667,
    stroke: "#1B1836",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0f264e5cc2ac4cb3a7bd54396f4f0ccf.svg";
export { ForwardRef as ReactComponent };